// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_LegalClientBeneficiaryController_UpdateById_Input_ControlOverLegalClientStatus,
  MutationInput_LegalClientBeneficiaryController_UpdateById_Input_PepConnectionType as PepConnectionTypeApi,
  UpdateLegalClientBeneficiaryByAdminDto_Input,
} from 'api/generated/graphql';
import { RelationType } from 'api/types/entity';
import { UpdateLegalClientBeneficiaryParams } from 'api/types/params';
import { formatToISODate } from 'helpers';

import { parseIdentityDocumentParam, parsePriceParam } from '../parseParam';

const relationType: Record<RelationType, PepConnectionTypeApi> = {
  [RelationType.not]: PepConnectionTypeApi.None,
  [RelationType.yesSpouses]: PepConnectionTypeApi.FamilyMember,
  [RelationType.yesIAm]: PepConnectionTypeApi.Self,
};

export const parseUpdateLegalClientBeneficiaryParams = (
  params: UpdateLegalClientBeneficiaryParams
): UpdateLegalClientBeneficiaryByAdminDto_Input => ({
  versionNumber: params.versionNumber,
  firstName: params.firstName,
  lastName: params.lastName,
  middleName: params.middleName,
  dateOfBirth: formatToISODate(params.dateOfBirth),
  citizenships: params.citizenships,

  reason: params.reason,

  registrationAddress: params.registrationAddress,
  residentialAddress: params.residentialAddress,
  taxResidences: params.taxResidences,

  connectedPepInfo: params.connectedPepInfo,

  pepConnectionType: relationType[params.pepConnection],

  placeOfBirth: params.placeOfBirth,
  directCapitalParticipationPercentage:
    params.directCapitalParticipationPercentage,

  financialConditionAmount: params.financialConditionAmount
    ? parsePriceParam(params.financialConditionAmount)
    : undefined,

  hasControlOverLegalClient: params.hasControlOverLegalClient,
  indirectCapitalParticipationPercentage:
    params.indirectCapitalParticipationPercentage,
  additionalInformationFileIds: params.additionalInformationFileIds,
  additionalDocumentFileIds: params.additionalDocumentFileIds,

  identityDocument: parseIdentityDocumentParam(params.identityDocument),

  selfieFileIds: params.selfieFileIds,

  controlOverLegalClientStatus: params.controlOverLegalClientStatus
    ? MutationInput_LegalClientBeneficiaryController_UpdateById_Input_ControlOverLegalClientStatus[
        params.controlOverLegalClientStatus
      ]
    : undefined,
});
